export const PROCEDURE_TYPES = [
  'Patient Status',
  'Procedure',
  'ICF',
  'Reminder',
  'Outreach',
  'Chart Review',
  'Checklist',
  'Patient Stipend'
];
